<div>
  @if (isFromGuide) {
    <app-task-info-tooltips
      [taskTitle]="'addManualAccount'"
      [taskDescription]="'balanceSaved'"
      [guideTitle]="'addManualAccount'"
      [bottomAction]="'return'"
      [tooltipLayout]="'overlayRight'"
      [currentStep]="ManualAccountGuideSteps.addTransaction"
      [totalSteps]="ManualAccountGuideTotalSteps"
    ></app-task-info-tooltips>
  }

  @if (
    tabActive() === editTransactionTab.transactionDetails &&
    selectedAccount() &&
    transactionFormReady()
  ) {
    <form
      *ngIf="transactionForm?.formGroup"
      [formGroup]="transactionForm.formGroup"
      name="accountForm"
    >
      <div class="tw-mb-6 tw-flex tw-flex-col tw-gap-6 tw-w-full">
        @if (checkAllowedType()) {
          <div class="tw-flex tw-flex-col tw-gap-1">
            <div class="tw-flex tw-items-center tw-justify-between">
              <label class="tw-text-[13px] tw-font-bold tw-text-dt-text-tertiary">
                {{ "transactionDescription" | i18n
                }}<span
                  [ngClass]="
                    transactionForm.formGroup.get('description')?.invalid &&
                    transactionForm.formGroup.get('description')?.touched
                      ? 'tw-text-danger'
                      : ''
                  "
                >
                  *</span
                >
              </label>
              <div class="tw-flex tw-items-center tw-gap-2">
                <span
                  class="tw-rounded-full tw-bg-[#6E56CF]/20 tw-px-2 tw-py-1 tw-text-[13px] tw-font-medium tw-leading-[125%] tw-tracking-[0.01em] tw-text-[#6E56CF]"
                >
                  {{ displaySourceText() | i18n }}
                </span>
                <app-gloss-button
                  *ngIf="isEditExistingTransaction() && updateTransaction()"
                  [options]="updateTransaction()"
                ></app-gloss-button>
              </div>
            </div>
            <app-input
              class="tw-w-full"
              [multiline]="true"
              [isRequired]="true"
              [placeholder]="'Add transaction description...'"
              [value]="transactionForm.formGroup.value.description"
              [manualTouched]="transactionForm.formGroup.controls.description.touched"
              (outputValue)="transactionForm.onInput($event, 'description')"
              testId="transaction-description-input"
            >
            </app-input>
            <span class="tw-text-sm tw-text-neutral-600">
              {{ "descriptionDisplayed" | i18n }}
            </span>
          </div>
        }

        <div class="tw-flex tw-justify-between tw-gap-6 tb:tw-flex-col">
          <!--      price-->
          <div class="tw-w-1/2 xs:tw-w-full">
            <app-input
              class="tw-w-full"
              [isDisabled]="isPriceLocked()"
              [label]="transactionForm.getPriceInputLabel()"
              [isRequired]="true"
              [type]="'number'"
              [value]="transactionForm.formGroup.value.amount"
              [manualTouched]="transactionForm.formGroup.controls.amount.touched"
              (outputValue)="transactionForm.onInput($event, 'amount')"
            ></app-input>
          </div>
          <!--      currency-->
          <app-currencies
            *ngIf="transactionForm"
            class="tw-w-1/2"
            [disabled]="isLockedCurrency()"
            [defaultCurrency]="currency()"
            (onSelectCurrency)="onCurrencySelected($event)"
            [label]="transactionForm.i18nService.t('currency')"
            [detachPanel]="true"
          ></app-currencies>
        </div>

        <div class="tw-flex tw-justify-between tw-gap-6 tb:tw-flex-col">
          <app-auto-transaction-direction
            class="tw-w-1/2 xs:tw-w-full"
            [label]="'transactionDirection'"
            [isRequired]="true"
            [direction]="transactionForm.formGroup.value.type"
            (directionChange)="transactionForm.selectDirection($event)"
          ></app-auto-transaction-direction>

          <!-- Date picker: neumorphic trigger + app-calendar (single date) in a CDK overlay -->
          <div class="tw-flex tw-w-1/2 xs:tw-w-full tw-flex-col tw-gap-1">
            <span class="tw-text-[13px] sm:tw-text-[12px] tw-font-bold tw-text-dt-text-tertiary">
              {{ "date" | i18n }}
            </span>
            <app-date-field
              [displayText]="transactionForm.formGroup.value.date"
              [dateFilter]="dateFilter"
              [isInvalid]="
                transactionForm.formGroup.get('date').invalid &&
                !transactionForm.formGroup.get('date').untouched
              "
              (dateChange)="onDatePicked($event)"
            ></app-date-field>
          </div>
        </div>

        <!--        <app-input-->
        <!--          class="tw-w-full"-->
        <!--          [label]="this.i18nService.t('time')"-->
        <!--          [isRequired]="false"-->
        <!--          [type]="InputTypes.time"-->
        <!--          [placeholder]="'00:00:00'"-->
        <!--          [manualTouched]="transactionForm.formGroup.controls.time.touched"-->
        <!--          (outputValue)="transactionForm.onInput(event, 'time')"-->
        <!--        ></app-input>-->

        @if (
          selectedAccount().type === accountManualType.stock ||
          selectedAccount().type === accountManualType.other
        ) {
          <div class="tw-flex tw-gap-4 tw-w-full">
            <!--        symbol-->
            <div class="tw-flex tw-w-1/2 xs:tw-w-full">
              <div class="tw-w-full tw-flex tw-flex-col tw-gap-1">
                <app-dropdown-select
                  [label]="'symbol' | i18n"
                  class="tw-w-full"
                  [isEnabled]="true"
                  [selectedOption]="transactionForm.formGroup.value.symbol"
                  [options]="symbolsAndCurrencies()"
                  (optionSelected)="onStockSymbolSelected($event)"
                  [customShadowClass]="'tw-shadow-dropdown'"
                  [showGradientBorder]="false"
                  [detachPanel]="true"
                >
                </app-dropdown-select>
                <div
                  class="tw-text-sm tw-text-neutral-600 tw-underline tw-cursor-pointer"
                  (click)="openAddSymbolDialog()"
                >
                  {{ "symbolNotFound" | i18n }}
                </div>
              </div>
            </div>
            <!--        amount-->
            <app-input
              class="tw-w-1/2 sm:tw-w-full"
              [label]="'amount' | i18n"
              [value]="transactionForm.formGroup.value.quantity"
              [manualTouched]="transactionForm.formGroup.controls.quantity.touched"
              [isRequired]="true"
              [type]="'number'"
              (outputValue)="transactionForm.selectQuantity($event)"
            >
            </app-input>
          </div>
        }

        @if (checkAllowedType() && liveSummaryText(); as summary) {
          <div
            class="tw-flex tw-w-full tw-items-start tw-gap-2.5 tw-rounded-xl tw-border-[1.5px] tw-border-color-accent-today-bg tw-bg-color-accent-today-bg tw-p-3.5"
            role="status"
            aria-live="polite"
          >
            <icon
              [name]="'receipt-dollar'"
              [size]="5"
              aria-hidden="true"
              class="tw-shrink-0 tw-text-color-text-action"
            ></icon>
            <span
              class="tw-flex-1 tw-text-[13px] tw-font-medium tw-leading-5 tw-text-color-text-action"
            >
              {{ summary }}
            </span>
          </div>
        }
      </div>
    </form>
  }

  @if (tabActive() === editTransactionTab.categories) {
    <app-category-select
      [categories]="userCategoriesNames()"
      [selectedName]="selectedCategories()[0]?.name ?? ''"
      (categorySelected)="onCategoryChange($event)"
      (categoryRemoved)="removeCategoryFromDisplay(selectedCategories()[0])"
      (categoryCreated)="createCategory($event)"
    ></app-category-select>
  }
</div>
